import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  caseStudyTitle: {
    marginBottom: theme.spacing(1),
  },
  caseInterviewTitle: {
    fontWeight: 500,
    color: theme.palette.primary['clr-400'],
    fontSize: '16px',
    marginBottom: theme.spacing(2),
  },
  caseDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    border: `1px solid ${theme.palette.neutral['clr-200']}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(4,6),
    height: '250px',
    maxHeight: '250px',
    boxShadow: `0px 4px 4px 0px #CCD4DE1A,
    0px 10px 20px 0px #CCD4DE29,
    0px 0px 4px 0px #CCD4DE` ,
    backgroundColor: theme.palette.shades['clr-white-900'],
  },
  caseDescription: {
    maxHeight : '200px',
    overflow : 'auto',
  },
  tooltipBox: {
    backgroundColor: theme.palette.primary['clr-50'],
    border: `1px solid ${theme.palette.primary['clr-100']}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5),
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 10,
    maxWidth: '300px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  },
  tooltipText: {
    fontSize: '12px',
    color: theme.palette.neutral['clr-700'],
    textAlign: 'center',
  },
}));

const CaseStudy = ({ caseMaster, followUps }) => {
  const classes = useStyles();

  const caseTitle = caseMaster?.title || 'Case Interview';
  const caseProblem = caseMaster?.problem || 'No case study problem available.';

  // Parse and format conversation
  const formatConversation = () => {
    const conversationLines = [];

    // Start with the case problem as the first interviewer message
    conversationLines.push({
      speaker: 'Interviewer',
      content: caseProblem
    });

    // Parse followUps conversation
    if (followUps && Array.isArray(followUps)) {
      followUps.forEach((item) => {
        if (item.role === 'user') {
          conversationLines.push({
            speaker: 'You',
            content: item.content
          });
        } else if (item.role === 'assistant') {
          try {
            // Parse the JSON string in assistant's content
            const parsedContent = JSON.parse(item.content);
            conversationLines.push({
              speaker: 'Interviewer',
              content: parsedContent.message || item.content
            });
          } catch (e) {
            // If parsing fails, use the raw content
            conversationLines.push({
              speaker: 'Interviewer',
              content: item.content
            });
          }
        }
      });
    }

    return conversationLines;
  };

  const conversation = formatConversation();

  return (
    <Box className={classes.container}>
      <Typography variant="h4-medium" className={classes.caseStudyTitle}>
        Feedback - Case Study
      </Typography>

      <Box className={classes.caseDescriptionContainer}>
        <Typography variant="h6-semiBold" color="primary.clr-400" sx={{ marginBottom: 2 }}>
          {caseTitle}
        </Typography>

        <Box className={classes.caseDescription}>
          {conversation.map((line, index) => (
            <Box key={index} sx={{ marginBottom: 2 }}>
              <Typography
                component="span"
                variant="body01-bold"
                color={line.speaker === 'Interviewer' ? 'primary.clr-400' : 'primary.main'}
              >
                {line.speaker}:
              </Typography>
              <Typography
                component="span"
                variant="body01-medium"
                color="neutral.clr-800"
                sx={{ marginLeft: 1 }}
              >
                {line.content}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CaseStudy;
